module.exports = __webpack_public_path__ + "static/FS-Barrier-1-4-793115cadf2ae9a7ecf1c81e92a8eb66.png";